import { gql } from "@apollo/client";
import Input from "components/common/form/inputs/Input";
import PageForm, { PageFormProps } from "components/common/page/PageForm";
import RoomTypeDropdownInput from "components/entities/accommodation/roomType/RoomTypeDropdownInput";
import { useState } from "react";
import { RoomFormDataQuery, RoomFormMutation, RoomFormMutationVariables } from "types/graphql";

const query = gql`
query RoomFormData($id: Int) {
    room(id: $id) {
      roomType {
        id
        name
        color
      }
      order
      name
      id
    }
  }
`;

const mutation = gql`
mutation RoomForm($model: RoomInput!) {
    room(model: $model)
    {
      id
    }
  }
`;

type Model = {
    id: number;
    name: string;
    order?: number | string;
    roomType?: {
        id: number;
        name: string;
        color?: string;
    }
};

const RoomFormPage = () => {
    const [model, setModel] = useState<Model>({
        id: 0,
        name: '',
    });

    const pageConfig: PageFormProps<RoomFormDataQuery, RoomFormMutation, RoomFormMutationVariables> = {
        title: 'pages.accommodation.room.form',
        name: 'room-form-page',
        load: {
            query,
            resolveQueyData(data) {
                if (data?.room) {
                    setModel({
                        id: data.room.id,
                        name: data.room.name,
                        order: data.room.order || undefined,
                        roomType: {
                            id: data.room.roomType!.id,
                            name: data.room.roomType!.name,
                            color: data.room.roomType!.color || undefined,
                        },
                    })
                }
            },
        },
        onSubmit: {
            resolveMutationData() {
                return {
                    model: {
                        id: model.id,
                        name: model.name,
                        order: Number(model.order),
                        roomTypeId: model.roomType!.id,
                    }
                };
            },
            mutation
        }
    }

    return (
        <PageForm {...pageConfig}>
            <fieldset>
                <Input
                    name="name"
                    label="fields.name.name"
                    required
                    value={model.name}
                    onChange={e => setModel({ ...model, name: e || '' })}
                    maxLength={50}
                />
                <RoomTypeDropdownInput
                    required
                    value={model.roomType}
                    onChange={e => setModel({ ...model, roomType: e })}
                />
                <Input
                    name="order"
                    label="fields.order.name"
                    required
                    value={model.order?.toString()}
                    onChange={e => setModel({ ...model, order: e || '' })}
                    type="number"
                />
            </fieldset>
        </PageForm>
    );
};

export default RoomFormPage;
